import { createContext, useContext } from "react";
import { css } from "@emotion/react";
import { InputDisplayValue } from "../InputBase/InputDisplayValue";

export const SelectFieldInputWrapperContext = createContext<string | undefined>(
  undefined,
);

export const SelectFieldInputWrapper = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const value = useContext(SelectFieldInputWrapperContext);
  return (
    <div
      css={[
        css`
          position: relative;
          input[readonly] + div,
          input[disabled] + div {
            pointer-events: auto;
          }
        `,
        value
          ? css`
              input::placeholder {
                color: transparent;
              }
            `
          : css``,
      ]}
    >
      {children}
      <InputDisplayValue>{value}</InputDisplayValue>
    </div>
  );
};
